/* GiftGo shop filter (oct18l): client-side filter + sort over the in-section
   catalogue. Destination-hidden cards (destination.js) are never shown/counted. */
(function () {
  'use strict';
  var PAGE = 24;
  function init(root) {
    if (root.dataset.ggReady) return; root.dataset.ggReady = '1';
    var grid = root.querySelector('[data-gg-grid]'), results = root.querySelector('[data-gg-results]');
    var items = Array.prototype.slice.call(grid.querySelectorAll('.gg-fitem'));
    var countEl = root.querySelector('.gg-count'), empty = root.querySelector('.gg-empty');
    var moreWrap = root.querySelector('.gg-more-wrap'), nEl = root.querySelector('.gg-n');
    var sorts = root.querySelectorAll('[data-gg-sort]');
    var active = false, shown = PAGE;
    items.forEach(function (it) {
      it._p = parseFloat(it.dataset.price) || 0; it._r = +it.dataset.rank || 0;
      it._n = +it.dataset.new || 0; it._c = it.dataset.combo === '1';
      it._cats = (it.dataset.cat || '').split(' ');
    });
    function vals(n) {
      var out = [];
      root.querySelectorAll('input[name="' + n + '"]:checked').forEach(function (i) { if (out.indexOf(i.value) < 0) out.push(i.value); });
      return out;
    }
    function destHidden(it) { return it.classList.contains('destination-hidden'); }
    function run(resetPage) {
      if (resetPage) shown = PAGE;
      var p = vals('price'), s = vals('speed'), c = vals('cat'), k = p.length + s.length + c.length;
      var so = sorts[0] ? sorts[0].value : 'combo';
      root.querySelectorAll('.gg-dd').forEach(function (d) { d.classList.toggle('has', !!d.querySelector('input:checked')); });
      nEl.textContent = k ? '(' + k + ')' : '';
      results.hidden = !active; countEl.hidden = !active;
      if (!active) return;
      var match = items.filter(function (it) {
        if (destHidden(it)) return false;
        var pr = it._p;
        return (!p.length || p.some(function (r) { var ab = r.split('-'); return pr >= +ab[0] && pr < +ab[1]; })) &&
          (!s.length || s.indexOf(it.dataset.speed) > -1) &&
          (!c.length || c.some(function (x) { return it._cats.indexOf(x) > -1; }));
      });
      match.sort(function (a, b) {
        if (so === 'asc') return a._p - b._p || a._r - b._r;
        if (so === 'desc') return b._p - a._p || a._r - b._r;
        if (so === 'new') return b._n - a._n || a._r - b._r;
        if (so === 'combo') return (b._c - a._c) || a._r - b._r;
        return a._r - b._r;
      });
      var set = new Set(match);
      var frag = document.createDocumentFragment();
      match.forEach(function (it, i) { it.classList.remove('gg-off'); it.classList.toggle('gg-page', i >= shown); frag.appendChild(it); });
      items.forEach(function (it) { if (!set.has(it)) { it.classList.add('gg-off'); frag.appendChild(it); } });
      grid.appendChild(frag);
      countEl.textContent = match.length + (match.length === 1 ? ' gift' : ' gifts') + (k ? ' match your filters' : '');
      empty.hidden = match.length > 0;
      moreWrap.hidden = match.length <= shown;
    }
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type=checkbox]')) {
        root.querySelectorAll('input[name="' + t.name + '"][value="' + t.value + '"]').forEach(function (i) { i.checked = t.checked; });
      } else if (t.matches('[data-gg-sort]')) {
        sorts.forEach(function (x) { x.value = t.value; });
      } else return;
      active = true; run(true);
    });
    root.querySelectorAll('[data-gg-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
        sorts.forEach(function (x) { x.value = 'combo'; });
        active = false; run(true);
      });
    });
    root.querySelectorAll('[data-gg-open]').forEach(function (b) { b.addEventListener('click', function () { document.body.classList.add('gg-open'); }); });
    root.querySelectorAll('[data-gg-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.body.classList.remove('gg-open');
        if (b.classList.contains('gg-apply') && active) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    root.querySelector('[data-gg-more]').addEventListener('click', function () { shown += PAGE; run(false); });
    document.addEventListener('click', function (e) {
      root.querySelectorAll('.gg-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.body.classList.remove('gg-open'); root.querySelectorAll('.gg-dd[open]').forEach(function (d) { d.removeAttribute('open'); }); }
    });
    document.addEventListener('giftgo:destination-change', function () { run(false); });
    root._ggRun = run;
    run(true);
  }
  function boot() { document.querySelectorAll('[data-gg-sf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
